import { Box, Grid, Paper, Stack } from '@mui/material'
import React, { type ReactNode } from 'react'

import { PromotedScenarioPreviewChips } from 'components/test-suites/forms/test-suite-composition/PromotedScenarioPreviewChips'
import theme from 'theme'

import type { ScenarioPreview } from 'types/api/reliability-tests/preview'
import type {
  FailureFlagNode,
  GraphNode,
  InfraAttackNode
} from 'types/api/scenarios/scenario'

export const GraphNodeWrapper: React.FC<{
  details: ReactNode
  impact: ReactNode
  isClickable: boolean
  node: InfraAttackNode | FailureFlagNode
  onClick?: (node: GraphNode) => void
  rowActions?: ReactNode
  scenarioPreview?: ScenarioPreview
}> = ({
  details,
  impact,
  isClickable,
  node,
  onClick,
  rowActions,
  scenarioPreview
}) => {
  return (
    <Paper
      sx={{
        width: 'fit-content',
        minWidth: 500,
        maxWidth: 800,
        padding: 1,
        margin: `${theme.space[3]}px 0`
      }}
      onClick={isClickable && onClick ? () => onClick(node) : undefined}
    >
      <Stack>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Grid item aria-label="Experiment" pl={1} xs={5}>
            <Stack alignItems="center" direction="row" justifyContent="left">
              {details}
            </Stack>
          </Grid>
          <Grid item xs>
            <Stack alignItems="center" direction="row" justifyContent="center">
              {impact}
            </Stack>
          </Grid>
          <Grid item xs={1}>
            {rowActions}
          </Grid>
        </Grid>
      </Stack>
      {scenarioPreview && (
        <Box mt={1}>
          <PromotedScenarioPreviewChips
            scenarioPreview={scenarioPreview}
            step={node}
          />
        </Box>
      )}
    </Paper>
  )
}
